import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

const MAX_IFRAME_HEIGHT_PX = 1008; // ~10.5in at 96dpi
const DEFAULT_IFRAME_HEIGHT_PX = 720;

const fitIframeToContent = (iframe) => {
    if (!iframe) return;

    try {
        const doc = iframe.contentDocument || iframe.contentWindow?.document;
        const body = doc?.body;
        const html = doc?.documentElement;
        if (!body) return;

        const contentHeight = Math.max(
            body.scrollHeight,
            body.offsetHeight,
            html?.scrollHeight || 0,
            html?.offsetHeight || 0
        );

        if (contentHeight > 0) {
            const height = Math.min(contentHeight + 8, MAX_IFRAME_HEIGHT_PX);
            iframe.style.width = '100%';
            iframe.style.height = `${height}px`;
            if (iframe.parentElement) {
                iframe.parentElement.style.width = '100%';
                iframe.parentElement.style.height = `${height}px`;
            }
        }
    } catch {
        iframe.style.width = '100%';
        iframe.style.height = `${DEFAULT_IFRAME_HEIGHT_PX}px`;
        if (iframe.parentElement) {
            iframe.parentElement.style.width = '100%';
            iframe.parentElement.style.height = `${DEFAULT_IFRAME_HEIGHT_PX}px`;
        }
    }
};

const MedicineInvoicePrintFrame = ({ printUrl, onLoad, title }) => {
    const handleLoad = useCallback(
        (event) => {
            const iframe = event.currentTarget;
            fitIframeToContent(iframe);
            setTimeout(() => fitIframeToContent(iframe), 300);
            onLoad?.();
        },
        [onLoad]
    );

    return (
        <div className="medicine-invoice-print-frame">
            <iframe
                src={printUrl}
                title={title || 'Medicine invoice'}
                onLoad={handleLoad}
            />
        </div>
    );
};

MedicineInvoicePrintFrame.propTypes = {
    printUrl: PropTypes.string.isRequired,
    onLoad: PropTypes.func,
    title: PropTypes.string,
};

export default MedicineInvoicePrintFrame;
